<template>
  <div class="h-9 flex justify-between items-center gap-1">
    <button
      class="w-9 rounded-xl m-0 flex items-center"
      @mousedown="startPress('previous')"
      @mouseup="stopPress"
      @mouseleave="stopPress"
    >
      ◄
    </button>
    <input class="basicInput !w-[130px]" 
      type="date" 
      v-model="selectedDate" 
      @keydown.prevent   
      @paste.prevent
      @wheel.prevent
      @change="updateDates"
    />
    <button
      class="w-9 rounded-xl m-0 flex items-center"
      @mousedown="startPress('next')"
      @mouseup="stopPress"
      @mouseleave="stopPress"
    >
      ►
    </button>
  </div>
</template>

<script>
import { inject } from 'vue';

import {  parse } from 'date-fns';

export default {
  setup() {
    const state = inject('state');
    return { state };
  },
  data() {
    return {
      selectedDate: this.formatDate(new Date()), // Liaison avec Flatpickr
      pressInterval: null,
      pressTimeout: null,
      initialDelay: 300,
    };
  },
  methods: {
    formatDate(date) {
      const d = new Date(date)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`   // YYYY-MM-DD en local
    },
    startPress(direction) {
      this.navigateDays(direction);
      this.pressTimeout = setTimeout(() => {
        this.pressInterval = setInterval(() => {
          this.navigateDays(direction);
        }, this.state.selectedView.speed);
      }, this.initialDelay);
    },
    updateDates(){
      if (!/^\d{4}-\d{2}-\d{2}$/.test(this.selectedDate)) {
        return;
      }
      const dayDiff = Math.floor((this.state.endDate - this.state.startDate) / (1000 * 60 * 60 * 24));
      const parsedDate = parse(this.selectedDate, 'yyyy-MM-dd', new Date());
      this.state.startDate = new Date(parsedDate);
      this.state.endDate = new Date(parsedDate.setDate(parsedDate.getDate() + dayDiff));
    },
    navigateDays(direction = 'next'){
      const daysDoAdd = direction === 'next' ? this.state.selectedView.add : -this.state.selectedView.add;
      const dayDiff = Math.round((this.state.endDate - this.state.startDate) / (1000 * 60 * 60 * 24));
      
      this.state.startDate = new Date(this.state.startDate.setDate(this.state.startDate.getDate() + daysDoAdd));
      this.state.endDate = new Date(new Date(this.state.startDate).setDate(this.state.startDate.getDate() + dayDiff));
    },
    stopPress() {
      clearTimeout(this.pressTimeout);
      clearInterval(this.pressInterval);
      this.pressTimeout = null;
      this.pressInterval = null;
    },
  },
  watch:{
    'state.startDate': function(newDate) {
      this.selectedDate = this.formatDate(newDate);
    }
  }
};
</script>